import { Storage } from '../memento/storage';
import { ServiceFactory } from './factory/service-factory';

export class AccountService extends ServiceFactory {

  static #instance;
  static #factory;
  static #services;

  constructor() {
    super();

    this.accountId = Storage.getItem('user').accountId;
  }

  static getInstance() {

    if (!this.#instance) {

      this.#instance = new AccountService();
      this.#services = this.#instance.#endpoints();
      this.#factory = this.#instance.#buildFactory();
    }

    return this.#factory;
  }

  #endpoints = () => {
    return {
      getAccounts: {
        method: 'GET',
        uri: '/accounts'
      },
      getAccount: {
        method: 'GET',
        uri: `/accounts/${this.accountId}`
      },
      downloadPayment: {
        method: 'GET',
        uri: '/accounts'
      },
      setAccount: {
        method: 'PATCH',
        uri: `/accounts/${this.accountId}`
      },
      setAccounts: {
        method: 'PATCH',
        uri: '/accounts'
      },
      setPayment: {
        method: 'PATCH',
        uri: '/accounts'
      },
      getSupplier: {
        method: 'GET',
        uri: '/accounts'
      },
      getExcel: {
        method: 'POST',
        uri: '/anexos/reporte'
      },
      getExcelVolaris: {
        method: 'GET',
        uri: '/anexos/excel/reporte-proveedor-volaris'
      },
      getBlackListReport: {
        method: 'GET',
        uri: '/reportes/listas-negras'
      },
      getYearsProsecutors: {
        method: 'GET',
        uri: '/reportes/anios-fiscales'
      },
      getPreRegistrationExcel: {
        method: 'GET',
        uri: '/datos/proveedoresgruposalinas/excel-report'
      }
    };
  };

  #buildFactory = () => super.buildFactory()(this.#endpoints());
}
